export const state = {
  isLoading: false,
  error: '',
};
